<template>
  <div class="flex-page">
    <div class="flex-1">
      <section class="express-container">
        <h4 class="express-title">填写物流单号</h4>

        <van-field
          class="invoice-cell cell-title select-cell"
          :border="false"
          readonly
          clickable
          label="快递公司"
          :value="expressCom"
          right-icon="cap-arrow"
          placeholder="请选择"
          @click="routerPage()"
        />

        <!-- <van-cell
          :border="false"
          class="invoice-cell cell-title select-cell"
          title="快递公司"
          @click="routerPage()"
          is-link
          :value="expressCom || '请选择'"
        /> -->

        <van-field
          class="invoice-cell cell-title lang-label"
          label="快递单号"
          placeholder="请输入快递单号"
          placeholder-right
          input-align="right"
          v-model="expressNo"
          :formatter="formatterTaxNum"
          clearable
          maxlength="50"
          :border="false"
        />
      </section>
    </div>
    <footer class="footer">
      <van-button type="primary" round size="middle" block @click="submit">提交</van-button>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expressNo: '',
      refundId: '',
      expressCom: '',
      expressComCode: ''
    };
  },
  created() {
    const { refundId, expressCom, expressComCode } = this.$route.query;
    this.refundId = refundId;
    this.expressCom = expressCom;
    this.expressComCode = expressComCode;
  },
  methods: {
    formatterTaxNum(value) {
      return value.replace(/[^\w]/g, '');
    },
    submit() {
      if (!this.expressCom) {
        this.$toast('请选择快递公司');
        return;
      }
      if (!this.expressNo) {
        this.$toast('请输入快递单号');
        return;
      }
      this.$fetch
        .uploadExpressInfo({
          refundOrderSn: this.refundId,
          expressCom: this.expressCom,
          expressComCode: this.expressComCode,
          expressCode: this.expressNo
        })
        .then((res) => {
          this.$router.replace(`refund/${this.refundId}`);
        });
    },
    routerPage() {
      this.$router.replace(`/select-company?refundId=${this.refundId}&expressComCode=${this.expressComCode}`);
    }
  }
};
</script>

<style lang="less" scoped>
.flex-page {
  display: flex;
  height: 100%;
  min-height: 100%;
  flex-direction: column;
  background: #f5f5f5;
  .flex-1 {
    flex: 1;
    overflow: auto;
    padding: 12px;
  }
  .express-container {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    padding: 8px 12px;
    color: #262626;
    h4.express-title {
      font-size: 16px;
      padding: 8px 0 12px;
    }
  }
  .footer {
    padding: 8px 16px;
    background: #ffffff;
  }

  .invoice-cell {
    padding: 10px 0;
    /deep/ .van-cell__title {
      color: #262626;
      font-size: 14px;
      line-height: 20px;
    }
    /deep/ .van-cell__value {
      font-size: 14px;
      input::placeholder {
        font-size: 14px;
      }
    }
    /deep/ .van-icon {
      font-size: 14px;
    }
  }
  .select-cell /deep/ .van-cell__flexrow {
    .van-field__control {
      text-align: right;
    }
    .van-field__right-icon {
      padding: 0 0 0 8px;
      margin: 0;
    }
    .van-icon-arrow {
      color: #bfbfbf;
    }
    .van-icon-cap-arrow {
      color: #bfbfbf;
      font-size: 12px;
    }
  }

  .cell-title /deep/ .van-cell__flexrow {
    .van-cell__title {
      color: #262626;
    }
  }
  .cell-title /deep/.van-cell::after {
    border: 0 !important;
  }
}
</style>